module.exports = __webpack_public_path__ + "img/01.8da72341.jpg";